import { gsap } from 'gsap';

export default function homePageScript() {
    const heroSection = document.querySelector<HTMLElement>('#home_page .hero');
    const hero = document.querySelector<HTMLElement>('#home_page .hero-stage');
    const slides = Array.from(document.querySelectorAll<HTMLElement>('#home_page .hero-slide'));
    const header = document.querySelector<HTMLElement>('#header');

    if (!heroSection || !hero || !slides.length) return;

    function syncHeroHeight() {
        const headerOffset = header?.offsetHeight ?? 0;
        document.documentElement.style.setProperty('--header-offset', `${headerOffset}px`);
    }

    // syncHeroHeight();
    // window.addEventListener('resize', syncHeroHeight);

    if (slides.length === 1) {
        gsap.set(slides[0], { opacity: 1 });
        return;
    }

    gsap.set(slides, { opacity: 0 });
    gsap.set(slides[0], { opacity: 1 });

    const timeline = gsap.timeline({
        repeat: -1,
        repeatDelay: 0.2,
        paused: true,
    });

    slides.forEach((slide, index) => {
        const nextSlide = slides[(index + 1) % slides.length];

        timeline
            .to(
                nextSlide,
                {
                    opacity: 1,
                    duration: 1.8,
                    ease: 'power2.inOut',
                },
                '+=3.2'
            )
            .to(
                slide,
                {
                    opacity: 0,
                    duration: 1.8,
                    ease: 'power2.inOut',
                },
                '<'
            );
    });

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry?.isIntersecting) {
                timeline.resume();
                return;
            }

            timeline.pause();
        },
        {
            threshold: 0.15,
        }
    );

    observer.observe(heroSection);
}
